
export class ParadaSolicitadaModel {

  creador: any;
  parada: any;
  ruta: any;


}
